import React from 'react';
import madhuPhoto from '../assets/MADHU_PHOTO.jpg';

export default function Hero() {
  const scrollTo = (href) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-bg" />
      <div className="hero-grid" />

      <div className="hero-inner">
        {/* ── Text side ── */}
        <div className="hero-text">
          <div className="hero-badge">
            <span className="hero-badge-dot" />
            Open to Work · ReactJS &amp; MERN Stack
          </div>

          <h1 className="hero-name">
            MADHUMITHA<span> V</span>
          </h1>

          <p className="hero-title">Frontend Developer &amp; MERN Stack Engineer</p>

          <p className="hero-desc">
            Building scalable, responsive web applications with{' '}
            <strong style={{ color: 'var(--text)' }}>2+ years of experience</strong>. Passionate
            about clean UI, accessibility, and crafting delightful user experiences with ReactJS,
            TypeScript, and the MERN stack.
          </p>

          <div className="hero-actions">
            <button className="btn-primary" onClick={() => scrollTo('#contact')}>
              💬 Get In Touch
            </button>
            <a href="/Resume.pdf" download className="btn-secondary">
              ⬇ Download Resume
            </a>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <div className="stat-num">2+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat">
              <div className="stat-num">5+</div>
              <div className="stat-label">Projects Delivered</div>
            </div>
            <div className="stat">
              <div className="stat-num">4+</div>
              <div className="stat-label">Certifications</div>
            </div>
          </div>
        </div>

        {/* ── Photo side ── */}
        <div className="hero-photo-wrap">
          <div className="hero-photo-frame">
            <img
              src={madhuPhoto}
              alt="Madhumitha V — Frontend Developer"
              className="hero-photo"
            />
          </div>
          <div className="photo-badge">
            <div className="photo-badge-icon">⚛️</div>
            <div className="photo-badge-label">
              <strong>ReactJS Developer</strong>
              Chennai, India
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
